import React, { Component } from "react";
import { connect } from "react-redux";
import { translate } from "react-translate";

import { ErrorMessagePopup } from "../../base_components";
import Command from "../command";
import DashboardButton from "../dashboard_button";
import PlantSettingsButton from "../plant_settings/PlantSettingsButton";
import { resetCommandStatus } from "./actions";

import colors from "../../../values/colors";
import { Errors } from "../../../values/strings";
import { getBorderText3 } from "../../../utils/utils";
import { types as CommandTypes } from "../../../values/commands";
import urls from "../../../values/urls";

class CommandList extends Component {
  renderErrorPopup() {
    const { error } = this.props.command;

    if (!error) return null;

    const text = error.response
      ? Errors["ERROR_" + error.response.status]
      : Errors.ERROR_CONN_REFUSED;

    return (
      <ErrorMessagePopup
        idModal={this.idErrorPopupModal}
        text={text}
        onHide={() => this.props.resetCommandStatus()}
        show
      />
    );
  }

  renderTitle() {
    const { title, idPlant, t } = this.props;

    if (!title && !idPlant) return null;

    const titleEl = title ? (
      <h1 className="page-title" style={_style.title}>
        {title}
      </h1>
    ) : null;

    return (
      <div style={_style.titleContainer}>
        {this.renderLegendScrollButton(t)}
        {titleEl}
        {!!idPlant && <PlantSettingsButton plantId={idPlant} />}
      </div>
    );
  }

  renderStaffCommand(/* type, href */) {
    /*
    const { user, idPlant, idSensor } = this.props;
    return user.user.is_staff && !idPlant && !!idSensor ? (
      <Command idSensor={idSensor} type={type} href={href} />
    ) : null;
    */

    return null;
  }

  renderLegendScrollButton(t) {
    return (
      <button
        onClick={() => {
          const el = document.getElementById('status-legend');
          if (el) el.scrollIntoView({behavior: 'smooth'});
        }}
        style={_style.legendScrollBtn}
        title={t('scroll_to_legend')}
      >
        <span className="material-symbols-outlined" style={_style.legendScrollIcon}>question_mark</span>
      </button>
    );
  }

  renderCameraCommand() {
    const { idSensor } = this.props;
    return !!idSensor ? (
      <Command
        idSensor={idSensor}
        type={CommandTypes.CAMERA}
        href={`${urls.DASHBOARD_BASE}/sensors/camera-feed/${idSensor}/`}
      />
    ) : null;
  }

  renderDashboardButton() {
    const { idSensor, dashboardUrl } = this.props;
    // Solo a livello sensore e solo se la dashboard è configurata.
    return !!idSensor && !!dashboardUrl ? (
      <DashboardButton idSensor={idSensor} dashboardUrl={dashboardUrl} />
    ) : null;
  }

  renderControlCommands() {
    const { idPlant, idSensor, initialChecked = {}, plantsSiren, showLionKing = true } = this.props;
    const sirenDisabled =
      this.props.sirenDisabled || (!!idPlant && plantsSiren[idPlant]);

    let result = [
      <Command
        switchButton
        idSensor={idSensor}
        idPlant={idPlant}
        plantName={this.props.title}
        type={CommandTypes.IDLE}
        initialChecked={!initialChecked[CommandTypes.IDLE]}
        confirmDisable
        key={idPlant + "_1"}
      />,

      <Command
        switchButton
        idSensor={idSensor}
        idPlant={idPlant}
        plantName={this.props.title}
        type={CommandTypes.SIREN}
        disabled={sirenDisabled}
        // TRYFIX: use actual value, before it was default to false
        initialChecked={initialChecked[CommandTypes.SIREN]}
        waitForNewStates
        key={idPlant + "_2"}
      />,

      <Command
        switchButton
        idSensor={idSensor}
        idPlant={idPlant}
        plantName={this.props.title}
        type={CommandTypes.LIGHT}
        // TRYFIX: use actual value, before it was default to false
        initialChecked={initialChecked[CommandTypes.LIGHT]}
        waitForNewStates
        key={idPlant + "_3"}
      />,

      showLionKing && <Command
        switchButton
        idSensor={idSensor}
        idPlant={idPlant}
        plantName={this.props.title}
        type={CommandTypes.LION_KING}
        initialChecked={initialChecked[CommandTypes.LION_KING]}
        confirmDisable
        key={idPlant + "_4"}
      />,
    ];

    return result;
  }

  render() {
    return (
      <div style={_style.container}>
        {this.renderTitle()}

        <div className="dashboard-track-commands" style={_style.list}>
          {this.renderCameraCommand()}

          {this.renderDashboardButton()}

          {this.renderStaffCommand(CommandTypes.RESTART)}

          {this.renderControlCommands()}
        </div>

        {this.renderErrorPopup()}
      </div>
    );
  }
}

const mapStateToProps = ({ command, user, plantsSiren }) => {
  return { command, user, plantsSiren };
};

export default connect(mapStateToProps, { resetCommandStatus })(translate("CommandList")(CommandList));

const _style = {
  container: {
    margin: "0 0 1rem 0",
    padding: ".8rem 1rem",
    border: "1.5px solid",
    backgroundColor: colors.secondaryLight,
    borderColor: colors.secondaryDark,
    borderRadius: 16,
  },
  list: {
    display: "flex",
    flexDirection: "row",
    // justifyContent: see style.css
    alignItems: "center",
  },
  title: {
    display: "block",
    textAlign: "center",
    color: colors.creamLight,
    textShadow: getBorderText3(colors.disabledDark),
    flex: 1,
  },
  titleContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: ".5rem 0 1.5rem 0",
  },
  settingsButton: {
    justifySelf: "flex-end",
  },
  legendScrollBtn: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  legendScrollIcon: {
    fontSize: 32,
    color: 'rgb(70, 70, 70)',
    border: '2px solid rgb(70, 70, 70)',
    borderRadius: '100%',
    padding: 4,
    backgroundColor: 'white',
  },
};
